module.exports = __webpack_public_path__ + "img/lock.221947e3.jpg";